module.exports = ".hello{\r\n    color:#C0C0C0,\r\n}"